module.exports = __webpack_public_path__ + "img/person_niuchaoye.6fe5cd9c.jpg";